import { InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';
import { IEnvironment } from '../environments/environment.type';

export const APP_CONFIG: InjectionToken<IAppConfig> = new InjectionToken<IAppConfig>('app.config');

export interface IAppConfig {
    environment: IEnvironment;
}
// Global App Config
export const AppConfig: IAppConfig = {
  environment: environment
};
